import { useEffect, useRef, useState } from "react";
import { RotatingLines } from "react-loader-spinner";
import axios from "axios";
import "./style.css";
import { toast } from "react-toastify";
import { Typography, Autocomplete, Chip, Stack } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DoubleArrowOutlined from "@mui/icons-material/DoubleArrowOutlined";
import LocalParkingOutlined from "@mui/icons-material/LocalParkingOutlined";
import AccountBalanceOutlined from "@mui/icons-material/AccountBalanceOutlined";
import LocationOnOutlined from "@mui/icons-material/LocationOnOutlined";
import FiberPinTwoTone from "@mui/icons-material/FiberPinTwoTone";
import RouteOutlined from "@mui/icons-material/RouteOutlined";
import ExpandMore from "@mui/icons-material/ExpandMore";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { post } from "../../services";
import Cookies from "js-cookie";

const NewStore = () => {
  const [pincode, setPincode] = useState();
  const [road, setRoad] = useState(null);
  const [isLoader, setIsLoader] = useState(false);
  const [isDetailsLoader, setIsDetailsLoader] = useState(false);
  const [options, setOptions] = useState([]);
  const [mapData, setMapData] = useState();
  const [pageUrl, setPageUrl] = useState();
  const [detailsData, setDetailsData] = useState([]);
  const [parkingData, setParkingData] = useState([]);
  const [tcaData, setTcaData] = useState([]);
  const [retailData, setRetailData] = useState([]);
  const [isDisplay, setIsDisplay] = useState(false);
  const [shouldDisplay, setShouldDisplay] = useState(false);
  const [ppi, setPpi] = useState();
  const [rai, setRai] = useState();
  const iframeRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  const handleClick = () => {
    window.open(pageUrl, "_blank");
  };

  const handleKeyUp = (event) => {
    setOptions([]);
    setRoad(null);
    setDetailsData([]);
    const inputValue = event.target.value;
    if (inputValue.length === 6) {
      setIsLoader(true);
      setOptions([]);
      setPincode(inputValue);
      getDetails(inputValue);
      setShouldDisplay(true);
    } else {
      setShouldDisplay(false);
    }
  };

  const getDetails = async (pincode) => {
    setIsDisplay(false);
    const payload = {
      pincode: pincode,
      event: "get_road_list",
    };

    axios
      .post(
        "https://qjs5zmb53qpnhuo67p7ditmbke0phavz.lambda-url.ap-south-1.on.aws/",
        payload,
        {
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      )
      .then((response) => {
        console.log("Response data:", response.data);
        convertOption(response.data);
      })
      .catch((error) => {
        console.error("Errors:", error);
        setIsLoader(false);
        setIsDisplay(false);
      });
  };

  const convertOption = (data) => {
    let newOptions = [];
    data?.forEach((item) => {
      const opData = {
        label: item,
        value: item,
      };
      newOptions.push(opData);
    });
    setOptions([...options, ...newOptions]);
    setIsLoader(false);
    setIsDisplay(true);
  };

  useEffect(() => {
    setOptions([]);
    setDetailsData([]);
  }, [pincode]);

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
  };

  const handleBlur = () => {
    setTimeout(() => {
      inputRef.current.focus();
    }, 0);
  };
  useEffect(() => {
    if (road && inputRef.current) {
      inputRef.current.blur();
    }
  }, [road]);

  const handleChange = (event, value) => {
    setRoad(value.value);
    setMapData();
    setPageUrl();
    setParkingData([]);
    setRetailData([]);
    setTcaData([]);
    setInputValue(value);
    setIsDetailsLoader(true);
    if (inputRef.current) inputRef.current.focus();
    const payload = {
      pincode: pincode,
      road_selected: value.value,
      event: "get_road_details",
    };
    axios({
      method: "post",
      url: "https://qjs5zmb53qpnhuo67p7ditmbke0phavz.lambda-url.ap-south-1.on.aws/",
      data: payload,
      headers: {
        Authorization: Cookies.get("ssp_sso_token"),
        "content-type": "application/json",
      },
    })
      .then((response) => {
        console.log("Response data:", response.data);
        const uniqData = [
          ...new Set(response.data.data_list[0].retail_proxy_names),
        ];
        setDetailsData(response.data.data_list);
        setMapData(response.data.data_list[0]);
        setPageUrl(response.data.page_url);
        setParkingData(response.data.data_list[0].parking_names);
        setRetailData(uniqData);
        setPpi(response.data.data_list[0].ppi);
        setRai(response.data.data_list[0].rai_index);
        setTcaData(response.data.data_list[0].tca_names.slice(0, 30));
        setIsDetailsLoader(false);
      })
      .catch((error) => {
        setIsDetailsLoader(false);
        toast.error(error.message);
        console.error("Error Test:", error);
      });
  };

  return (
    <div>
      <div class=" mx-auto mt-8 flex-row relative">
        <div
          style={{
            backgroundColor: "#FFFFFF",
            borderColor: "#F1F6FA",
            borderWidth: 1,
            borderRadius: 20,
            height: 188,
          }}
        >
          <div style={{}}>
            <Typography
              style={{
                fontSize: "21px",
                fontWeight: "400",
                lineHeight: "32px",
                color: "#172128",
                marginTop: 20,
                marginLeft: 12,
              }}
            >
              new store opening
            </Typography>
            <Typography
              className=" text-base font-[400] leading-6 text-[#808C96]"
              style={{
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                color: "#808C96",
                paddingTop: 12,
                marginLeft: 12,
              }}
            >
              Pincode Potential Index & Road Attractiveness Index
            </Typography>
            <div
              className=" flex "
              style={{
                marginLeft: 12,
                marginTop: 20,
                marginBottom: 20,
              }}
            >
              <div style={{ width: 300, height: 48 }}>
                <label
                  htmlFor="input-group-1"
                  className="block mb-2 text-xs text-gray-900"
                >
                  Pincode
                </label>
                <div className="relative mb-2 w-3/10">
                  {" "}
                  {/* Set width to 30% */}
                  <div className="absolute inset-y-0 start-0 flex items-center pl-2 pointer-events-none">
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        backgroundColor: "#FFF",
                        padding: 8,
                        borderRadius: 12,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FiberPinTwoTone
                        style={{ height: 20, width: 20, color: "#FA4B16" }}
                      />
                    </div>
                  </div>
                  <input
                    type="text"
                    id="input-group-1"
                    maxLength={6}
                    className="bg-gray-50 border pl-14 border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full h-12"
                    placeholder="Enter a six digit area pincode"
                    onKeyUp={handleKeyUp}
                    ref={inputRef}
                  />
                </div>
              </div>
              {isDisplay ? (
                <div style={{ width: "30%", height: 48 }} className=" ml-5">
                  <label
                    htmlFor="input-group-1"
                    className="block mb-2 text-xs text-gray-900"
                  >
                    Road{" "}
                  </label>
                  <div className="relative mb-2 w-3/10">
                    {" "}
                    {/* Set width to 30% */}
                    <div className="absolute inset-y-0 start-0 flex items-center pl-2 pointer-events-none">
                      <div
                        style={{
                          width: 40,
                          height: 40,
                          backgroundColor: "#FFF",
                          padding: 8,
                          borderRadius: 12,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <RouteOutlined
                          style={{ height: 20, width: 20, color: "#FA4B16" }}
                        />
                      </div>
                    </div>
                    <Autocomplete
                      disablePortal
                      options={options}
                      value={road}
                      onChange={handleChange}
                      inputValue={inputValue}
                      onInputChange={handleInputChange}
                      renderInput={(params) => (
                        <div ref={params.InputProps.ref}>
                          <input
                            placeholder="Select a Road"
                            onBlur={handleBlur}
                            {...params.inputProps}
                            className="bg-gray-50 border pl-14 pr-10 border-gray-300 text-gray-900 text-xs rounded-lg  block w-full h-12"
                          />
                          <ExpandMore
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "10px",
                              transform: "translateY(-50%)",
                            }}
                          />
                        </div>
                      )}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div
                    style={{
                      marginTop: 40,
                      marginLeft: 20,
                    }}
                  >
                    <RotatingLines
                      visible={shouldDisplay}
                      height="20"
                      width="20"
                      color="red"
                      strokeWidth="5"
                      animationDuration="0.25"
                      ariaLabel="rotating-lines-loading"
                      strokeColor="#FA4B16"
                      wrapperStyle={{ top: 20 }}
                      wrapperClass="ml-10"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className=" border rounded-md p-3 mt-6"
        style={{ backgroundColor: "#F1F6FA" }}
      >
        {isDetailsLoader ? (
          <Typography>Data being loaded ...</Typography>
        ) : detailsData.length > 0 ? (
          <>
            <div className="flex flex-row justify-between w-full ">
              <div
                className="border border-gray-300 rounded-md w-full p-3"
                style={{
                  backgroundColor: "#FFF",
                  borderRadius: 20,
                  border: "1px solid #E4EAF0",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: "400",
                    color: "#172128",
                  }}
                >
                  PPI
                </Typography>
                <Typography
                  sx={{
                    fontSize: 12,
                    top: 4,
                    marginBottom: 2,
                    fontWeight: "400",
                    color: "#6A777F",
                  }}
                >
                  Pincode Potential Index
                </Typography>
                <div
                  className="progress"
                  style={{
                    border:
                      ppi < 80
                        ? "1px solid #FA4B16"
                        : ppi > 80 && ppi < 120
                        ? "1px solid #D78014"
                        : "1px solid #008A29",
                  }}
                >
                  <div className="progress-bar">
                    <div
                      className="progress-bar-filled"
                      style={{
                        width: `${ppi / 2}%`,
                        minWidth: "5%",
                        backgroundColor:
                          ppi < 80
                            ? "#FA4B16"
                            : ppi > 80 && ppi < 120
                            ? "#D78014"
                            : "#008A29",
                      }}
                      aria-valuenow={ppi / 2}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <span className="sr-only">{`${ppi / 2}% Complete`}</span>
                      <span
                        className="progress-line"
                        style={{
                          position: "absolute", // Set position to absolute
                          left: "40%", // Position it 1/3 of the way from the left
                          top: "40%",
                          height: "30%",
                          width: 1,
                          backgroundColor:
                            ppi < 80
                              ? "#FA4B16"
                              : ppi > 80 && ppi < 120
                              ? "#FA4B16"
                              : "#FA4B16",
                        }}
                      ></span>
                      <span
                        className="progress-line"
                        style={{
                          position: "absolute", // Set position to absolute
                          left: "60%", // Position it 1/3 of the way from the left
                          top: "40%",
                          height: "30%",
                          width: 1,
                          backgroundColor:
                            ppi < 80
                              ? "#D78014"
                              : ppi > 80 && ppi < 120
                              ? "#D78014"
                              : "#D78014",
                        }}
                      ></span>
                      <div
                        className="progress-value"
                        style={{ width: `${ppi / 2}%`, minWidth: "5%" }}
                      >
                        <span className="progress-bar-text">
                          {parseFloat(ppi).toFixed(1)}
                        </span>
                      </div>
                    </div>
                    <div
                      className="progress-bar-unfilled"
                      style={{ width: `100-${ppi / 2}%` }}
                      aria-valuenow={100 - ppi / 2}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <span className="sr-only">{`${ppi / 2}% Remaining`}</span>
                    </div>
                  </div>
                </div>
                {/* <BorderLinearProgress variant="determinate" value={} sx={{paddingBototm:12}}/>  */}
              </div>
              <div
                className="border border-gray-300 rounded-md  w-full"
                style={{
                  backgroundColor: "#FFF",
                  padding: 12,
                  marginLeft: 12,
                  borderRadius: 20,
                  border: "1px solid #E4EAF0",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 16,
                    // lineHeight:24,
                    fontWeight: "400",
                    color: "#172128",
                  }}
                >
                  RAI
                </Typography>
                <Typography
                  sx={{
                    fontSize: 12,
                    top: 4,
                    marginBottom: 2,
                    // lineHeight:24,
                    fontWeight: "400",
                    color: "#6A777F",
                  }}
                >
                  Road Attractiveness Index
                </Typography>
                <div
                  className="progress-rai"
                  style={{
                    border:
                      rai < 20
                        ? "1px solid #FA4B16"
                        : rai > 20 && rai < 30
                        ? "1px solid #D78014"
                        : "1px solid #008A29",
                  }}
                >
                  <div className="progress-bar">
                    <div
                      className="progress-bar-filled-rai"
                      style={{
                        width: `${rai / 2}%`,
                        minWidth: "5%",
                        backgroundColor:
                          rai < 20
                            ? "#FA4B16"
                            : rai > 20 && rai < 30
                            ? "#D78014"
                            : "#008A29",
                      }}
                      aria-valuenow={rai / 2}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <span className="sr-only">{`${rai / 2}% Complete`}</span>
                      <span
                        className="progress-line"
                        style={{
                          position: "absolute", // Set position to absolute
                          left: "10%", // Position it 1/3 of the way from the left
                          top: "40%",
                          height: "30%",
                          width: 1,
                          backgroundColor:
                            rai < 20
                              ? "#FA4B16"
                              : rai > 20 && rai < 30
                              ? "#FA4B16"
                              : "#FA4B16",
                        }}
                      ></span>
                      <span
                        className="progress-line"
                        style={{
                          position: "absolute", // Set position to absolute
                          left: "15%", // Position it 1/3 of the way from the left
                          top: "40%",
                          height: "30%",
                          width: 1,
                          backgroundColor:
                            rai < 20
                              ? "#D78014"
                              : rai > 20 && rai < 30
                              ? "#D78014"
                              : "#D78014",
                        }}
                      ></span>
                      <span
                        className="progress-value"
                        style={{ width: `${rai / 2}%`, minWidth: "5%" }}
                      >
                        <span className="progress-bar-text">
                          {parseFloat(rai).toFixed(1)}
                        </span>
                      </span>
                    </div>
                    <div
                      className="progress-bar-unfilled"
                      style={{ width: `100 - ${30}%` }}
                      aria-valuenow={100 - rai / 2}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <span className="sr-only">{`${rai / 2}% Remaining`}</span>
                    </div>
                  </div>
                </div>
                {/* <BorderLinearProgress variant="determinate" value={50} /> */}
              </div>
            </div>
            <div className="flex justify-between w-full">
              <div className="w-full">
                <div
                  className=" border border-gray-300 rounded-md"
                  style={{
                    backgroundColor: "#FFF",
                    padding: 12,
                    marginTop: 12,
                    marginBottom: 12,
                    borderRadius: 20,
                    border: "1px solid #E4EAF0",
                  }}
                >
                  <Typography>nearby retail attraction </Typography>
                  <div
                    style={{
                      backgroundColor: "#F1F6FA",
                      borderRadius: 16,
                      padding: 12,
                      marginTop: 12,
                    }}
                  >
                    {retailData.map((item) => {
                      return (
                        <div style={{ display: "inline-flex", padding: 4 }}>
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                          >
                            <Chip
                              icon={
                                <LocationOnOutlined
                                  style={{
                                    height: 16,
                                    width: 16,
                                    marginLeft: 8,
                                  }}
                                />
                              }
                              label={item}
                              style={{
                                textAlign: "left",
                                maxWidth: "200px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                backgroundColor: "#172128",
                                color: "#ffffff",
                              }}
                            />
                          </Stack>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div
                  className=" border border-gray-300 rounded-md"
                  style={{
                    padding: 12,
                    backgroundColor: "#FFF",
                    marginTop: 12,
                    marginBottom: 12,
                    borderRadius: 20,
                    border: "1px solid #E4EAF0",
                  }}
                >
                  <Typography>nearby commercial proxy </Typography>
                  <div
                    style={{
                      backgroundColor: "#F1F6FA",
                      borderRadius: 16,
                      padding: 12,
                      marginTop: 12,
                    }}
                  >
                    {tcaData.map((item) => {
                      return (
                        <div style={{ display: "inline-flex", padding: 4 }}>
                          <Stack direction="row" spacing={1}>
                            <Chip
                              icon={
                                <LocationOnOutlined
                                  style={{
                                    height: 16,
                                    width: 16,
                                    marginLeft: 8,
                                  }}
                                />
                              }
                              label={item}
                              style={{
                                backgroundColor: "#172128",
                                color: "#ffffff",
                              }}
                            />
                          </Stack>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div
                  className=" border border-gray-300 rounded-md"
                  style={{
                    padding: 12,
                    backgroundColor: "#FFF",
                    marginTop: 12,
                    marginBottom: 12,
                    borderRadius: 20,
                    border: "1px solid #E4EAF0",
                  }}
                >
                  <Typography>nearby parking spots </Typography>
                  <div
                    style={{
                      backgroundColor: "#F1F6FA",
                      borderRadius: 16,
                      padding: 12,
                      marginTop: 12,
                    }}
                  >
                    {parkingData.map((item) => {
                      return (
                        <div style={{ display: "inline-flex", padding: 4 }}>
                          <Stack direction="row" spacing={1}>
                            <Chip
                              icon={
                                <LocalParkingOutlined
                                  style={{
                                    height: 16,
                                    width: 16,
                                    marginLeft: 8,
                                  }}
                                />
                              }
                              label={item}
                              style={{
                                backgroundColor: "#172128",
                                color: "#ffffff",
                              }}
                            />
                          </Stack>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div
                className="w-full"
                style={{
                  margin: 12,
                  borderRadius: 20,
                  border: "1px solid #E4EAF0",
                }}
              >
                <div className="w-full">
                  <iframe
                    ref={iframeRef}
                    title="Map"
                    width="100%"
                    height="400"
                    loading="lazy"
                    allowFullScreen
                    src={pageUrl}
                    className="w-full"
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "40%",
                      right: 0,
                      left: "60%",
                      width: "40%",
                      height: "75%",
                      backgroundColor: "transparent",
                      cursor: "pointer",
                    }}
                    onClick={handleClick}
                  ></div>
                </div>
                <div
                  className=" border border-gray-300 rounded-md"
                  style={{
                    padding: 12,
                    backgroundColor: "#FFF",
                    margin: 12,
                    borderRadius: 20,
                    border: "1px solid #E4EAF0",
                  }}
                >
                  <Typography>Steps To Get Street View</Typography>
                  <div
                    style={{
                      backgroundColor: "#F1F6FA",
                      borderRadius: 16,
                      padding: 12,
                      marginTop: 12,
                    }}
                  >
                    <ul>
                      <li style={{}}>
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          <DoubleArrowOutlined
                            style={{ height: 16, width: 16 }}
                          />
                          <Typography>Click on the above map</Typography>
                        </div>
                      </li>
                      <li style={{}}>
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "flex-start",
                          }}
                        >
                          <DoubleArrowOutlined
                            style={{ height: 16, width: 16, marginTop: 4 }}
                          />
                          <Typography>
                            Click on (grey star) for commercial proxy and ( red
                            start ) for retail proxy
                          </Typography>
                        </div>
                      </li>
                      <li style={{}}>
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          <DoubleArrowOutlined
                            style={{ height: 16, width: 16 }}
                          />
                          <Typography>
                            Click on the Name of the proxy
                          </Typography>
                        </div>
                      </li>

                      <li style={{}}>
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          <DoubleArrowOutlined
                            style={{ height: 16, width: 16 }}
                          />
                          <Typography>
                            Click on this Icon to open street view
                          </Typography>
                          <img
                            src={require("../../Assets/strret.png")}
                            style={{ height: 50, width: 50, marginLeft: 20 }}
                            alt="My Image"
                          />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <img
                src={require("../../Assets/home.png")}
                alt={"logo"}
                loading="lazy"
                style={{ height: 342, height: 200 }}
              />
            </div>
            <div
              style={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                marginTop: 24,
              }}
            >
              <Typography
                style={{
                  fontSize: 12,
                  fontWeight: "400",
                  color: "#172128",
                }}
              >
                Select a pincode & then a road to view their details
              </Typography>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default NewStore;
